import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const Loading = ({ label, className, size, color }) => {
    const defaultClass = 'ckp-loading';
    return (
        <span className={`${defaultClass} ${className ? className : ''}`}>
            {label ? <span className={`${defaultClass}-label`}>{label}</span> : null}
            <CircularProgress
                style={{ color: color || 'primary' }}
                className={`${defaultClass}-spinner`}
                size={size || 30}
            />
        </span>
    );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/helpers/Loading.js